import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class nudbCreateUserComponent implements OnInit {

  loading: boolean = false;
  constructor() { }

  ngOnInit() {
  }
}
